import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as copy from "copy-to-clipboard";
const SupportProject = () => {
    const [isCopied, setIsCopied] = useState(false);
    const { t } = useTranslation();
    const handleCopy = () => {
        copy("0x494014A23E0f1Dd9D890C04967385F6491597f15", {
            format: "text/plain",
            onCopy(_clipboardData) {
                setIsCopied(true);
            },
        });
    };
    return (React.createElement("section", { id: "support", className: "support-project" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "support-project__inner" },
                React.createElement("div", { className: "support-project__header" },
                    React.createElement("div", { className: "support-project__logo" },
                        React.createElement("img", { className: "support-project__logo-img", width: "204", height: "204", src: "../../../../images/welcome/support-project-logo.svg", alt: "logo icon" })),
                    React.createElement("div", { className: "support-project__info" },
                        React.createElement("h4", { className: "support-project__label" }, t("welcomepage.supportProject.header")),
                        React.createElement("p", { className: "support-project__descr" }, t("welcomepage.supportProject.description")))),
                React.createElement("div", { className: "support-project__middle" },
                    React.createElement("h2", { className: "support-project__title" }, t("welcomepage.supportProject.button")),
                    React.createElement("h3", { className: "support-project__subtitle" }, t("welcomepage.supportProject.investToYourFuture")),
                    React.createElement("div", { className: "support-project__btn btn", style: {
                            width: "max-content",
                            maxWidth: "100%",
                            position: "relative",
                        }, onClick: handleCopy },
                        React.createElement("p", { className: "support-text" }, "0x494014A23E0f1Dd9D890C04967385F6491597f15"),
                        isCopied ? (React.createElement("img", { src: "../../../../images/welcome/icons/copied.svg", alt: "checked", style: {
                                paddingLeft: "10px",
                            } })) : (React.createElement("img", { src: "../../../../images/welcome/icons/copy.svg", alt: "copy", style: {
                                paddingLeft: "10px",
                            } }))))))));
};
export default SupportProject;
